import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-installdialog',
  templateUrl: './installdialog.component.html',
  styleUrls: ['./installdialog.component.css']
})
export class InstalldialogComponent implements OnInit {

  deferredPrompt;

  constructor(
    private dialogRef: MatDialogRef<InstalldialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
    this.dialogRef.updatePosition({ top: '10px', right: '10px' });
   this.deferredPrompt = this.data;
  }

  onClose = () => {
    this.dialogRef.close();
  }

  installClicked = () => {

    if(this.deferredPrompt){
      this.deferredPrompt.prompt();
    }
    
    // Wait for the user to respond to the prompt
    this.deferredPrompt.userChoice.then((choiceResult) => {
      if (choiceResult.outcome === 'accepted') {
        console.log('User accepted the install prompt');
      } else {
        console.log('User dismissed the install prompt');
      }
      this.deferredPrompt = null;
    });

    this.dialogRef.close();
  }
}
